import { render, staticRenderFns } from "./Sections.vue?vue&type=template&id=41431878&scoped=true"
import script from "./Sections.vue?vue&type=script&lang=js"
export * from "./Sections.vue?vue&type=script&lang=js"
import style0 from "./Sections.vue?vue&type=style&index=0&id=41431878&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41431878",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41431878')) {
      api.createRecord('41431878', component.options)
    } else {
      api.reload('41431878', component.options)
    }
    module.hot.accept("./Sections.vue?vue&type=template&id=41431878&scoped=true", function () {
      api.rerender('41431878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/rubricSetting/Add/components/Sections.vue"
export default component.exports